import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Loader
} from 'lucide-react'; // Make sure Loader is imported
import AgentStudioSidebar from './AgentStudioSidebar';
import AgentOverview from './AgentOverview';
import AgentResources from './AgentResources';
import AgentBuilder from './AgentBuilder';
import AgentTestComponent from '../AgentTestComponent';
import StreamingLogs from './TracesAndLogs';
import AgentMetricsDashboard from './AgentMetrics';
import AgentDeploymentPanel from './AgentDeploymentPanel';
import { AgentProps } from '../Interfaces/AgentProps';
import { agentService } from '../services/agentService';

const AgentStudio = () => {
    const { agentId } = useParams();
    const navigate = useNavigate();
    const [agent, setAgent] = useState<AgentProps | undefined>(undefined);
    const [selectedSection, setSelectedSection] = useState('Overview');
    const [collapsed, setCollapsed] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchAgent = async () => {
            if (!agentId) return;
            setLoading(true);
            try {
                const agentData = await agentService.getAgentById(agentId);
                setAgent(agentData);
            } catch (err) {
                console.error('Failed to fetch agent:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchAgent();
    }, [agentId]);

    const isSidebarDisabled = !agent?.id;

    return (
        <div className="flex h-[calc(100vh-64px)]">
            <AgentStudioSidebar
                selected={{ name: agent?.title ?? 'Untitled Agent', section: selectedSection }}
                onSelect={isSidebarDisabled ? () => { } : setSelectedSection}
                collapsed={collapsed}
                setCollapsed={setCollapsed}
                disabled={!agent}
            />

            <main className="flex-1 overflow-y-auto bg-black p-4">
                {/* Loader while waiting for agent fetch */}
                {agentId && loading && (
                    <div className="flex items-center justify-center h-full">
                        <Loader className="w-8 h-8 animate-spin text-gray-400" />
                    </div>
                )}

                {/* Initial Create */}
                {!agentId && selectedSection === 'Overview' && (
                    <AgentOverview
                        onSave={(updatedAgent) => {
                            setAgent(updatedAgent);
                            navigate(`/portal/agentStudio/${updatedAgent.id}`);
                        }}
                    />
                )}

                {/* Loaded agent sections */}
                {agent && selectedSection === 'Overview' && (
                    <AgentOverview
                        agent={agent}
                        onSave={(updatedAgent) => {
                            setAgent(updatedAgent);
                            navigate(`/portal/agentStudio/${updatedAgent.id}`);
                        }}
                    />
                )}
                {agent && selectedSection === 'Resources' && <AgentResources agent={agent} />}
                {agent && selectedSection === 'Builder' && <AgentBuilder agent={agent} />}
                {agent && selectedSection === 'Test Agent' && <AgentTestComponent agent={agent} />}
                {agent && selectedSection === 'Traces & Logs' && <StreamingLogs agent={agent} />}
                {agent && selectedSection === 'Metrics' && <AgentMetricsDashboard agent={agent} />}
                {agent && selectedSection === 'Deployments' && <AgentDeploymentPanel agent={agent} />}
            </main>
        </div>
    );
};

export default AgentStudio;


// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import AgentStudioSidebar from './AgentStudioSidebar';
// import AgentOverview from './AgentOverview';
// import AgentResources from './AgentResources';
// import AgentBuilder from './AgentBuilder';
// import AgentTestComponent from '../AgentTestComponent';
// import StreamingLogs from './TracesAndLogs';
// import AgentMetricsDashboard from './AgentMetrics';
// import AgentDeploymentPanel from './AgentDeploymentPanel';
// import { AgentProps } from '../Interfaces/AgentProps';
// import { agentService } from '../services/agentService';

// const AgentStudio = () => {
//   const { agentId } = useParams();
//   const [agent, setAgent] = useState<AgentProps | undefined>(undefined);
//   const [selectedSection, setSelectedSection] = useState('Overview');
//   const [collapsed, setCollapsed] = useState(false);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     const fetchAgent = async () => {
//       if (agentId) {
//         setLoading(true);
//         try {
//           const data = await agentService.getAgentById(agentId);
//           setAgent(data);
//         } catch (err) {
//           console.error('Failed to fetch agent:', err);
//         } finally {
//           setLoading(false);
//         }
//       }
//     };

//     fetchAgent();
//   }, [agentId]);

//   if (agentId && loading) {
//     return <div className="text-white p-6">Loading agent details...</div>;
//   }

//   if (agentId && !agent) {
//     return <div className="text-white p-6">Failed to load agent or agent not found.</div>;
//   }

//   return (
//     <div className="flex h-[calc(100vh-64px)]">
//       <AgentStudioSidebar
//         selected={{ name: agent?.title ?? 'Untitled Agent', section: selectedSection, key: agent?.key }}
//         onSelect={setSelectedSection}
//         collapsed={collapsed}
//         setCollapsed={setCollapsed}
//       />

//       <main className="flex-1 overflow-y-auto bg-black">
//         {selectedSection === 'Overview' && <AgentOverview agent={agent} />}
//         {selectedSection === 'Resources' && <AgentResources agent={agent} />}
//         {selectedSection === 'Builder' && <AgentBuilder agent={agent} />}
//         {selectedSection === 'Test Agent' && <AgentTestComponent agent={agent} />}
//         {selectedSection === 'Traces & Logs' && <StreamingLogs agent={agent} />}
//         {selectedSection === 'Metrics' && <AgentMetricsDashboard agent={agent} />}
//         {selectedSection === 'Deployments' && <AgentDeploymentPanel agent={agent} />}
//       </main>
//     </div>
//   );
// };

// export default AgentStudio;
